import { useState } from "react";
import { EonUiButton } from "@eon-ui/eon-ui-components-react";
import "./ExpertQueue.scss";

const MAX_LENGTH = 2000;

/**
 * A note on the request's Jira issue. It does not change the request, so it can be sent at any stage once the
 * issue exists. The backend writes it under its own account and prefixes it with who wrote it.
 */
export function CommentBox({
    onComment,
}: {
    onComment: (text: string) => Promise<unknown>;
}) {
    const [text, setText] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [sent, setSent] = useState(false);

    const send = async () => {
        const trimmed = text.trim();
        if (!trimmed || isSending) {
            return;
        }

        setIsSending(true);
        setError(null);
        setSent(false);
        try {
            await onComment(trimmed);
            setText("");
            setSent(true);
        } catch (caught) {
            setError(caught instanceof Error ? caught.message : String(caught));
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="expert-queue-item-detail-card-section">
            <label
                className="expert-queue-item-detail-card-section-label"
                htmlFor="queue-item-comment"
            >
                Add a note to the Jira issue
            </label>
            <textarea
                id="queue-item-comment"
                className="expert-queue-item-detail-card-comment-input"
                rows={2}
                maxLength={MAX_LENGTH}
                value={text}
                onChange={(event) => {
                    setText(event.target.value);
                    setSent(false);
                }}
                placeholder="Visible to everyone on the Jira issue"
            />
            {error && (
                <p className="queue-decision__error" role="alert">
                    {error}
                </p>
            )}
            {sent && (
                <p className="expert-queue-item-detail-card-section-text" role="status">
                    Note added.
                </p>
            )}
            <div>
                <EonUiButton
                    text="Add note"
                    rank="secondary"
                    size="small"
                    disabled={!text.trim() || isSending}
                    preloader={isSending}
                    onClick={() => void send()}
                />
            </div>
        </div>
    );
}

export default CommentBox;
